import React, { Component } from 'react';
import { Col } from 'reactstrap';

class Results extends Component {
    constructor(props) {
        super(props);

        this.state = {
            eco: [],
            ekg:[],
            holter:[],
            map: [],
            stress: [],
            test: [],
        }
    }

    componentDidMount() {
            
        this.setState({ eco: this.props.medicalProcedures.ECO,
                        ekg: this.props.medicalProcedures.EKG,
                        holter: this.props.medicalProcedures.Holter,
                        map: this.props.medicalProcedures.Map,
                        stress: this.props.medicalProcedures.stress,
                        test: this.props.medicalProcedures.test,
        });

        console.log(this.props.medicalProcedures);
        console.log(this.state.stress);
    }

    render() {

        return (<Col>
            <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
                <div className="card__title">
                    <h5 className="bold-text">Resultados Procedimientos</h5>
                </div>
            </div>
        </Col>);
    }
}

export default Results;